import { render, staticRenderFns } from "./PortalUserRegistration.vue?vue&type=template&id=1e0507ff&scoped=true&"
import script from "./PortalUserRegistration.vue?vue&type=script&lang=js&"
export * from "./PortalUserRegistration.vue?vue&type=script&lang=js&"
import style0 from "./PortalUserRegistration.vue?vue&type=style&index=0&id=1e0507ff&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e0507ff",
  null
  
)

export default component.exports